module.exports = "pegasus_template/assets/theme5/gallery-img3.png";